import { createContext } from 'react'

/** @type {import('react').Context<null | {
 *   selectedScheduleId: string | null,
 *   selectedScheduleKind: string | null,
 *   isOpen: boolean,
 *   openSchedule: (schedule: { id: string }) => void,
 *   closeSchedule: () => void,
 * }>} */
export const ScheduleDetailsContext = createContext(null)
